import React from "react";
import { createRoot } from 'react-dom/client';

import fe, { info } from "@randajan/simple-app/fe";


import screen from "@randajan/jet-react/base/screen";


import "@randajan/jet-react/dom/modal/css";
import "@randajan/jet-react/dom/img/css";
import "@randajan/jet-react/dom/form/css";
import "@randajan/jet-react/dom/menu/css";
import "@randajan/jet-react/dom/block/css";
import "@randajan/jet-react/dom/caption/css";
import "@randajan/jet-react/dom/table/css";
import "@randajan/jet-react/dom/counter/css";

import "./styles/*";
import "./assets/bases/*";
import "./assets/expose";


import { App } from "./frames/App/App";

const root = document.getElementById("root");

screen.config({
    widths:[600, 780, 960, 1280, 1920],
    heights:[300, 600, 920, 1280]
});

screen.watch("", _=>root.setAttribute("data-screen", screen.getList().join(" ")), true);


createRoot(root).render(<App/>);
